// this is an autogenerated file from App/Account/Content/Settings/Content/DocumentTemplates/Templates/ImportAction/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_DocumentTemplates_Templates_ImportAction_Content(
  $name: String!
  $organization_id: uuid!
  $file_key: String!
  $is_contract: Boolean
) {
  vaxiom_create_document_template(
    name: $name
    organization_id: $organization_id
    file_key: $file_key
    is_contract: $is_contract
  ) {
    id
  }
}

`